import { render, staticRenderFns } from "./Admin_pptMgmt_ler.vue?vue&type=template&id=e162b048&"
import script from "./Admin_pptMgmt_ler.vue?vue&type=script&lang=js&"
export * from "./Admin_pptMgmt_ler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports